import {SensorChartRenderContext} from '../sensor-chart/SensorChartRenderContext';

	export class OscilloRenderContext extends SensorChartRenderContext {

		public clearPosition: number;

		/**
		 * Previous series values buffer start time.
		 * End time is the chart minimum.
		 */
		public historyStart: number;

	}
